import React, { useEffect, useState, useCallback } from "react";
import { FaBars } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoIosClose } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import data from "../services";
import "./HeaderToggle.css";

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 999;
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  transition: opacity 0.3s, visibility 0.3s;
`;

const HeaderToggle = ({ headerRefIndex }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const getSelectedIndex = useCallback(() => {
    if (pathname === "/odalar" || pathname === "/oda-detay") return 1;
    if (pathname === "/hakkimizda") return 2;
    if (pathname === "/iletisim") return 4;
    if (pathname === "/surdurulebilirlik") return -1;
    return 0;
  }, [pathname]);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(getSelectedIndex());
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    setSelected(getSelectedIndex());
  }, [pathname, getSelectedIndex]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 15);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Menü açıkken body scroll'u engelle
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleTabClick = (index) => {
    setSelected(index);
    setIsOpen(false);

    switch (index) {
      case 0:
        if (pathname === '/') {
          headerRefIndex?.(0);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          navigate('/');
        }
        break;
      case 1:
        navigate('/odalar');
        break;
      case 2:
        navigate('/hakkimizda');
        break;
      case 3:
        if (pathname === '/') {
          headerRefIndex?.(3);
        } else {
          navigate('/?scroll=gallery');
        }
        break;
      case 4:
        navigate('/iletisim');
        break;
      default:
        headerRefIndex?.(index);
    }
  };

  return (
    <div className={`toggle-container ${!isScrolled && pathname === '/' ? 'toggle-transparent' : ''}`}>
      <div className="toggle-row">
        <div 
          className="toggle-name-row"
          onClick={() => handleTabClick(0)}
          style={{ cursor: 'pointer' }}
        >
          <h1 className="toggle-hotel-name">TİMYA</h1>
          <h3 className="toggle-hotel">Otel</h3>
        </div>
        <button 
          onClick={toggleMenu} 
          className="toggle-menu-button"
          aria-label="Menüyü aç"
        >
          <FaBars fontSize="40px" color="white" />
        </button>
      </div>
      
      <MenuContainer isOpen={isOpen}>
        <div className="toggle-icon-row">
          <button 
            onClick={toggleMenu}
            className="toggle-close-button"
            aria-label="Menüyü kapat"
          >
            <IoIosClose fontSize="50px" />
          </button>
        </div>
        
        <nav>
          {data.tabs.map((item, index) => (
            <div className="toggle-title-row" key={index}>
              <button
                className={selected === index ? "toggle-title-selected" : "toggle-title"}
                onClick={() => handleTabClick(index)}
                type="button"
              >
                {item}
              </button>
            </div>
          ))}
        </nav>
        
        <div className="social-icon-row">
          <a
            href="https://www.instagram.com/timyahotel"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FiInstagram className="icon" />
          </a>
        </div>
      </MenuContainer>
    </div>
  );
};

export default HeaderToggle;
